import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ModelNotification\RestoreToInboxModelNotificationController::__invoke
* @see app/Http/Controllers/ModelNotification/RestoreToInboxModelNotificationController.php
* @route '/api/restore-email'
*/
const RestoreToInboxModelNotificationController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: RestoreToInboxModelNotificationController.url(options),
    method: 'post',
})

RestoreToInboxModelNotificationController.definition = {
    methods: ["post"],
    url: '/api/restore-email',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ModelNotification\RestoreToInboxModelNotificationController::__invoke
* @see app/Http/Controllers/ModelNotification/RestoreToInboxModelNotificationController.php
* @route '/api/restore-email'
*/
RestoreToInboxModelNotificationController.url = (options?: RouteQueryOptions) => {
    return RestoreToInboxModelNotificationController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ModelNotification\RestoreToInboxModelNotificationController::__invoke
* @see app/Http/Controllers/ModelNotification/RestoreToInboxModelNotificationController.php
* @route '/api/restore-email'
*/
RestoreToInboxModelNotificationController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: RestoreToInboxModelNotificationController.url(options),
    method: 'post',
})

export default RestoreToInboxModelNotificationController